import axios from 'axios';
import { baseURL } from '../config';

export async function fetchCurrentProducts(ids, signal) {
  return Promise.all([...new Set(ids)].map(async id => {
    try {
      const response = await axios.get(`${baseURL}/products/${encodeURIComponent(id)}`, { signal, timeout: 15000 });
      const product = response?.data?.data;
      return product?._id === id ? { id, product } : { id, unavailable: true };
    } catch (error) {
      return { id, unavailable: [403, 404, 410].includes(error?.response?.status), error: ![403, 404, 410].includes(error?.response?.status) };
    }
  }));
}

export function plainProductText(value) {
  const document = new DOMParser().parseFromString(String(value || '').replace(/<\/(p|div|li|h[1-6])\s*>|<br\s*\/?>/gi, '\n'), 'text/html');
  document.querySelectorAll('script,style').forEach(node => node.remove());
  return (document.body.textContent || '').replace(/[ \t]+/g, ' ').replace(/\n\s*\n/g, '\n').trim();
}
